export default __webpack_public_path__ + "static/media/grupoabc.1cd52656.svg";